import { useQuery } from '@tanstack/react-query';

import { useEventbus } from './useEventbus';

import IdpHandlerInstance from '@user/IdpHandler';

export const useUser = () => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['idp-user'],
    queryFn: async () => {
      const idp = await IdpHandlerInstance.waitIdpReady();
      return {
        data: await idp.getCurrentUser(),
        logged: idp.isLogged(),
      };
    },
    placeholderData: {
      data: null,
      logged: false,
    },
  });

  useEventbus(() => {
    refetch();
  }, 'userLogged');

  return { ...data, isLoading };
};
